import { useState } from "react"
import { Phone, MapPin, Menu, X } from "lucide-react"

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <header
      className="site-header"
      style={{
        backgroundColor: "transparent",
        color: "white",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        width: "100%",
        zIndex: 100,
      }}
    >
      <div className="container mx-auto px-4 sm:px-6">
        {/* Top bar con logo y contacto */}
        <div
          className="flex justify-between items-center gap-4 py-2"
          style={{ height: "80px", alignItems: "center" }}
        >
          <div className="flex items-center gap-3">
            <div
              style={{ width: "72px", height: "72px", display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              <img
                src="/logo192.png"
                alt="Del Sol Centro Cambiario"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  filter: "drop-shadow(0 4px 6px rgba(0,0,0,0.3))",
                }}
              />
            </div>
            <span className="font-bold text-lg tracking-wide hidden sm:block" style={{ textShadow: '0 2px 8px rgba(0,0,0,0.4)' }}>
              DEL SOL
            </span>
          </div>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-8">
            <ul className="flex items-center gap-6 text-sm font-semibold tracking-wider">
              <li>
                <a href="#inicio" className="nav-link-header">INICIO</a>
              </li>
              <li>
                <a href="#por-que-elegirnos" className="nav-link-header">NOSOTROS</a>
              </li>
              <li>
                <a href="#footer" className="nav-link-header">CONTACTO</a>
              </li>
            </ul>
            <div className="h-5 w-px bg-white/20"></div>
            <div className="flex items-center gap-4 text-sm">
              <div className="flex items-center gap-1.5 opacity-85">
                <Phone className="w-3.5 h-3.5" />
                <span>686 568 13 00</span>
              </div>
              <div className="hidden xl:flex items-center gap-1.5 opacity-85">
                <MapPin className="w-3.5 h-3.5" />
                <span>Cuauhtémoc Norte 21200</span>
              </div>
            </div>
          </nav>

          {/* Mobile menu button */}
          <button
            className="lg:hidden p-2 rounded-lg transition-colors"
            style={{ backgroundColor: 'rgba(255,255,255,0.1)' }}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div 
            className="lg:hidden shadow-xl fade-in"
            style={{ 
              position: 'absolute',
              top: '80px',
              left: 0,
              right: 0,
              backgroundColor: 'rgba(168, 24, 24, 0.97)',
              backdropFilter: 'blur(12px)',
              borderTop: '1px solid rgba(255,255,255,0.15)',
              borderBottom: '1px solid rgba(255,255,255,0.1)',
              zIndex: 99,
              maxHeight: 'calc(100vh - 80px)',
              overflowY: 'auto'
            }}
          >
            <div className="px-4 sm:px-6 pb-4 pt-2 w-full" style={{ maxWidth: '100%', wordWrap: 'break-word' }}>
              <ul className="flex flex-col gap-2 py-3 text-sm break-words">
                <li>
                  <a href="#inicio" className="nav-link-header block py-2 px-3 rounded-lg" onClick={() => setMenuOpen(false)}>
                    INICIO
                  </a>
                </li>
                <li>
                  <a href="#por-que-elegirnos" className="nav-link-header block py-2 px-3 rounded-lg" onClick={() => setMenuOpen(false)}>
                    NOSOTROS
                  </a>
                </li>
                <li>
                  <a href="#footer" className="nav-link-header block py-2 px-3 rounded-lg" onClick={() => setMenuOpen(false)}>
                    CONTACTO
                  </a>
                </li>
              </ul>
              <div className="flex flex-col gap-2 px-3 pt-2 text-xs opacity-85 break-words" style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
                <div className="flex items-start gap-2">
                  <Phone className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" />
                  <span>686 568 13 00</span>
                </div>
                <div className="flex items-start gap-2">
                  <MapPin className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" />
                  <span>Cuauhtémoc Norte 21200</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  )
}